// import { createSlice } from '@reduxjs/toolkit'

// const initialState = {
//   cart: JSON.parse(localStorage.getItem("cart")) || [],
//   isLogin: localStorage.getItem('token') ? true : false,
// }

// export const cartSlice = createSlice({
//   name: 'cart',
//   initialState,
//   reducers: {
//     // addCartItem: (state, action) => {
//     //   const item = action.payload;
//     //   console.log(item)
//     //   const existingItem = state.cart.find((arr) => arr.cartItem.id === item.id);

//     //   if (existingItem) {
//     //     existingItem.itemQuantity += 1;
//     //   } else {
//     //     state.cart.push({ cartItem: item, itemQuantity: 1 });
//     //   }
//     //   localStorage.setItem("cart", JSON.stringify(state.cart));
//     // },
//     addCartItem: (state, action) => {
//       const { item, selectedVariation } = action.payload;

//       // Check if the item with the same variation exists
//       const existingItemIndex = state.cart.findIndex(
//         (cartItem) => cartItem.id === item.id &&
//           (selectedVariation ? cartItem.variation?.name === selectedVariation.name : !cartItem.variation)
//       );

//       if (existingItemIndex !== -1) {
//         // If item exists, increase quantity
//         state.cart[existingItemIndex].quantity += 1;
//       } else {
//         // If item doesn't exist, add it with the selected variation
//         const newItem = {
//           ...item,
//           quantity: 1,
//           variation: selectedVariation || null
//         };
//         state.cart.push(newItem);
//       }

//       localStorage.setItem("cart", JSON.stringify(state.cart));
//     },
//     removeCartItem: (state, action) => {
//       const { item, selectedVariation } = action.payload;

//       const existingItemIndex = state.cart.findIndex(
//         (cartItem) => cartItem.id === item.id &&
//           (selectedVariation ? cartItem.variation?.name === selectedVariation.name : !cartItem.variation)
//       );

//       if (existingItemIndex !== -1) {
//         if (state.cart[existingItemIndex].quantity > 1) {
//           // Decrease quantity if more than 1
//           state.cart[existingItemIndex].quantity -= 1;
//         } else {
//           // Remove item if quantity is 1
//           state.cart = state.cart.filter((_, index) => index !== existingItemIndex);
//         }
//       }

//       localStorage.setItem("cart", JSON.stringify(state.cart));
//     },

//     clearCart: (state, action) => {
//       const { item, selectedVariation } = action.payload;

//       state.cart = state.cart.filter(
//         (cartItem) => !(cartItem.id === item.id &&
//           (selectedVariation ? cartItem.variation?.name === selectedVariation.name : !cartItem.variation))
//       );

//       localStorage.setItem("cart", JSON.stringify(state.cart));
//     },

//     clearEntireCart: (state) => {
//       state.cart = [];
//       localStorage.removeItem("cart");
//     },
//     // removeCartItem: (state, action) => {
//     //   const item = action.payload;
//     //   const existingItem = state.cart.find((arr) => arr.cartItem.id === item.id);
//     //   if (existingItem) {
//     //     if (existingItem.itemQuantity > 1) {
//     //       existingItem.itemQuantity -= 1;
//     //     } else {
//     //       let filterItem = state.cart.filter((arr) => arr.cartItem.id !== item.id);
//     //       localStorage.setItem("cart", JSON.stringify(filterItem))
//     //       state.cart = filterItem

//     //     }
//     //   }
//     //   localStorage.setItem("cart", JSON.stringify(state.cart))
//     // },
//     // clearCart: (state, action) => {
//     //   const item = action.payload;
//     //   let filterItem = state.cart.filter((arr) => arr.cartItem.id !== item.id);
//     //   state.cart = filterItem
//     //   localStorage.setItem("cart", JSON.stringify(filterItem))
//     // },
//     // clearEntireCart: (state) => {
//     //   state.cart = []; // ✅ Clear the Redux cart state
//     //   localStorage.removeItem("cart"); // ✅ Also clear localStorage
//     // },
//   },
// })

// export const { addCartItem, removeCartItem, clearCart, clearEntireCart } = cartSlice.actions

// export default cartSlice.reducer

import { createSlice } from '@reduxjs/toolkit'
import { getVariationEffectivePrice } from '../../../utils/cartPriceUtils'

const initialState = {
  cart: JSON.parse(localStorage.getItem("cart")) || [],
  isLogin: localStorage.getItem('token') ? true : false,
}

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addCartItem: (state, action) => {
      const { item, selectedVariation, selectedAddOns = [], selectedDesserts = [], clearCart } = action.payload
      
      // Clear entire cart if clearCart flag is set
      if (clearCart) {
        state.cart = [];
      }
      
      // Calculate add-ons total price (add-ons use addons_price from modal)
      const addOnsPrice = selectedAddOns.reduce((sum, addOn) => sum + (addOn.price || 0), 0);
      const dessertsPrice = selectedDesserts.reduce((sum, dessert) => sum + (dessert.price || 0), 0);
      const addOnsTotalPrice = addOnsPrice + dessertsPrice;
      
      // Base price: for variation use calculated price (variation_item_discount) so cart matches modal
      let basePrice;
      if (selectedVariation) {
        if (selectedVariation.variation_item_discount != null || selectedVariation.variation_item_discount_type) {
          basePrice = getVariationEffectivePrice(selectedVariation);
        } else {
          basePrice = selectedVariation.discount_price != null ? selectedVariation.discount_price : selectedVariation.price;
        }
        basePrice = parseFloat(basePrice) || 0;
      } else {
        basePrice = parseFloat(item.item_price || item.discount_price || item.base_price || 0);
      }
      const totalItemPrice = basePrice + addOnsTotalPrice;
      
      // Create a unique identifier for the item+variation+addons combination
      const addOnsKey = selectedAddOns.length > 0 ? `-addons-${selectedAddOns.map(a => a.name).join('-')}` : '';
      const dessertsKey = selectedDesserts.length > 0 ? `-desserts-${selectedDesserts.map(d => d.name).join('-')}` : '';
      const itemId = selectedVariation
        ? `${item.id}-${selectedVariation.name}${addOnsKey}${dessertsKey}`
        : `${item.id}${addOnsKey}${dessertsKey}`;

      // Find the existing item with the same ID, variation, and add-ons
      const existingItemIndex = state.cart.findIndex(cartItem => {
        const sameItem = cartItem.id === item.id;
        const sameVariation = selectedVariation
          ? cartItem.variation?.name === selectedVariation.name
          : !cartItem.variation;
        const sameAddOns = JSON.stringify(cartItem.selectedAddOns || []) === JSON.stringify(selectedAddOns);
        const sameDesserts = JSON.stringify(cartItem.selectedDesserts || []) === JSON.stringify(selectedDesserts);
        
        return sameItem && sameVariation && sameAddOns && sameDesserts;
      });
      
      const variationList = Array.isArray(item.variation) ? item.variation : [];

      const allVariation = [
        {
          name: item.item_name,
          price: item.item_price || item.base_price,
          discount_price: item.discount_price || item.item_price || item.base_price
        },
        ...variationList
      ];

      if (existingItemIndex !== -1) {
        // If item exists, increase quantity
        state.cart[existingItemIndex].quantity += 1;
      } else {
        // If item doesn't exist, add it with the selected variation and add-ons
        // Ensure restaurant_id_new is set (checkout expects it; fallback to restaurant_id from regular API)
        const restaurantIdNew = item.restaurant_id_new ?? item.restaurant_id;
        const newItem = {
          ...item,
          ...(restaurantIdNew != null && { restaurant_id_new: restaurantIdNew }),
          quantity: 1,
          variation: selectedVariation
            ? {
              ...selectedVariation,
              price: String(selectedVariation.price),
              discount_price: String(selectedVariation.discount_price)
            }
            : {
              name: item.item_name,
              price: String(item.item_price || item.base_price),
              discount_price: String(item.discount_price || item.item_price || item.base_price)
            },
          // Store add-ons and desserts information
          selectedAddOns: selectedAddOns,
          selectedDesserts: selectedDesserts,
          // Store calculated prices
          basePrice: parseFloat(basePrice),
          addOnsPrice: addOnsTotalPrice,
          totalPrice: totalItemPrice,
          // Keep original prices for display
          price: selectedVariation ? selectedVariation.price : item.item_price || item.base_price,
          discount_price: totalItemPrice, // Use total price as the display price
          allVariation: allVariation
        };
        state.cart.push(newItem);
      }
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    removeCartItem: (state, action) => {
      const { item, selectedVariation, selectedAddOns = [], selectedDesserts = [] } = action.payload;
      
      // Find the existing item with the same ID, variation, and add-ons
      const existingItemIndex = state.cart.findIndex(cartItem => {
        const sameItem = cartItem.id === item.id;
        const sameVariation = selectedVariation
          ? cartItem.variation?.name === selectedVariation.name
          : !cartItem.variation;
        const sameAddOns = JSON.stringify(cartItem.selectedAddOns || []) === JSON.stringify(selectedAddOns);
        const sameDesserts = JSON.stringify(cartItem.selectedDesserts || []) === JSON.stringify(selectedDesserts);
        
        return sameItem && sameVariation && sameAddOns && sameDesserts;
      });

      if (existingItemIndex !== -1) {
        if (state.cart[existingItemIndex].quantity > 1) {
          // Decrease quantity if more than 1
          state.cart[existingItemIndex].quantity -= 1;
        } else {
          // Remove item if quantity is 1
          state.cart = state.cart.filter((_, index) => index !== existingItemIndex);
        }
      }

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    clearCart: (state, action) => {
      const { item, selectedVariation, selectedAddOns = [], selectedDesserts = [] } = action.payload;
      
      // Remove the specific item+variation+addons combination
      state.cart = state.cart.filter(cartItem => {
        const sameItem = cartItem.id === item.id;
        const sameVariation = selectedVariation
          ? cartItem.variation?.name === selectedVariation.name
          : !cartItem.variation;
        const sameAddOns = JSON.stringify(cartItem.selectedAddOns || []) === JSON.stringify(selectedAddOns);
        const sameDesserts = JSON.stringify(cartItem.selectedDesserts || []) === JSON.stringify(selectedDesserts);
        
        return !(sameItem && sameVariation && sameAddOns && sameDesserts);
      });
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    clearEntireCart: (state) => {
      state.cart = [];
      localStorage.removeItem("cart");
    },
  },
})

export const { addCartItem, removeCartItem, clearCart, clearEntireCart } = cartSlice.actions
export default cartSlice.reducer
